// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterOption } from '@/components/filter-toggle-group';
import {
  DoNotDisturbAltOutlined,
  EditOutlined,
  InventoryOutlined,
  KeyboardTabOutlined,
  ListRounded,
  LocalShippingOutlined,
  PendingOutlined,
  SettingsEthernetOutlined,
} from '@/constants/hardfin-standard-icons';
import { POPhase, POSubstatus } from '@/purchase-order/constants/status';

/**
 * Labels for PO modifier filter options.
 */
export const PO_MODIFIER_LABELS: Record<POSubstatus, string> = {
  partial: 'Partial',
  full: 'Full',
  overage: 'Overage',
};

/**
 * Filter options for the PO status filter bar.
 */
export const PO_STATUS_FILTER_OPTIONS: FilterOption<POPhase | 'all'>[] = [
  {
    value: 'all',
    label: 'All',
    icon: <ListRounded fontSize="small" />,
  },
  {
    value: 'draft',
    label: 'Draft',
    icon: <EditOutlined fontSize="small" />,
  },
  {
    value: 'awaiting_3pl',
    label: 'Awaiting 3PL',
    icon: <SettingsEthernetOutlined fontSize="small" />,
  },
  {
    value: 'open',
    label: 'Open',
    icon: <PendingOutlined fontSize="small" />,
  },
  {
    value: 'shipped',
    label: 'Shipped',
    icon: <LocalShippingOutlined fontSize="small" />,
  },
  {
    value: 'delivered',
    label: 'Delivered',
    icon: <KeyboardTabOutlined fontSize="small" />,
  },
  {
    value: 'received',
    label: 'Received',
    icon: <InventoryOutlined fontSize="small" />,
  },
  {
    value: 'cancelled',
    label: 'Cancelled',
    icon: <DoNotDisturbAltOutlined fontSize="small" />,
  },
];
